import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ion-text-center" }

import { IonBadge, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonTitle, IonToolbar, modalController } from '@ionic/vue';
import { translate } from '@hotwax/dxp-components';
import { closeOutline } from 'ionicons/icons';
import { computed, onMounted, ref } from "vue";
import { DateTime } from 'luxon';
import { ChannelService } from '@/services/ChannelService';
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobHistoryModal',
  props: ["currentJob"],
  setup(__props) {

const store = useStore();
const props = __props;

const jobHistory = ref([]) as any;

const getStatusDesc = computed(() => store.getters["channel/getStatusDesc"])

onMounted(async () => {
  await store.dispatch("channel/getServiceStatusDesc");
  fetchJobHistory();
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

function getDate(runTime: any) {
  return DateTime.fromMillis(runTime).toLocaleString(DateTime.DATE_MED);
}

function getTime(runTime: any) {
  return DateTime.fromMillis(runTime).toLocaleString(DateTime.TIME_SIMPLE);
}

async function fetchJobHistory() {
  jobHistory.value = await ChannelService.fetchJobInformation({
    "inputFields": {
      "productStoreId": props.currentJob.productStoreId,
      "statusId": ["SERVICE_CANCELLED", "SERVICE_CRASHED", "SERVICE_FAILED", "SERVICE_FINISHED"],
      "statusId_op": "in",
      "systemJobEnumId": props.currentJob.systemJobEnumId,
      "shopId_fld0_value": props.currentJob.shopId,
      "shopId_fld0_grp": "1",
      "shopId_fld0_op": "equals",
      "shopId_fld1_grp": "2",
      "shopId_fld1_op": "empty"
    },
    "fieldList": ["runTime", "statusId"],
    "noConditionFind": "Y",
    "viewSize": process.env.VUE_APP_VIEW_SIZE,
    "orderBy": "runTime DESC"
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.currentJob?.enumName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        (jobHistory.value?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobHistory.value, (job, index) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(job.runTime ? getTime(job.runTime) : "-") + " ", 1),
                            (job.runTime)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(getDate(job.runTime)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        (job.statusId)
                          ? (_openBlock(), _createBlock(_unref(IonBadge), {
                              key: 0,
                              color: job.statusId === 'SERVICE_FINISHED' ? 'success' : 'danger'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getStatusDesc.value(job.statusId)), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)("No available history for this job.")), 1)
            ]))
      ]),
      _: 1
    })
  ], 64))
}
}

})